import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../assets/open.png'
import _imports_1 from '@/assets/chat.png'


const _hoisted_1 = { class: "right" }

import UserVipInfoBtn from "@/components/Dialogues/Chat/UserVipInfoBtn.vue";
import { isCompactMode } from "@/data/pubilc";
import { isExpand } from "@/views/Home/useData/useHomePage";

import {
  dialogueStatus,
  dialogueList,
  init,
  addDialogue,
} from "@/views/Home/useData/module/dialogue";
import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { ElMessage } from "element-plus";
import { computed, onMounted } from "vue";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { storeToRefs } from "pinia";
import publicStore from "@/store/publicStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatHeader',
  setup(__props) {

const isReplying = computed(() => {
  return chatStatus.isReplying;
});
const { isLogin } = storeToRefs(publicStore());

// onMounted(() => {
//   init();
// });

const addNewDialogue = () => {
  if (!isLogin.value) {
    return openLoginDialog();
  }

  if (isReplying.value) {
    return ElMessage({
      message: "当前对话正在进行中，请先结束当前对话",
      type: "warning",
      duration: 1000,
    });
  }
  addDialogue();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { 'compact-header': _unref(isCompactMode) }])
  }, [
    (_unref(isCompactMode))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "expand-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isExpand.value = !_unref(isExpand)))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            src: _imports_0,
            height: "18",
            width: "18"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isCompactMode))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "btn",
            onClick: addNewDialogue
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "",
              srcset: ""
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createBlock(UserVipInfoBtn, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})